import { Permission, notEqual } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { TestingLab, useTestingLabsContext } from '../../TestingLabsContext'
import { useAuthContext } from 'context/AuthContext'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { useLabTechSelectContext } from 'components/CIMSSelect/common/LabTechSelect/LabTechSelectContext'
import { CreateEditTestingLabValues } from '../components/CreateEditBody/types'
import CreateEditBody from '../components/CreateEditBody'
import { useEditTestingLabMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'

export function useEdit(): EditRowActionOptions<
  TestingLab,
  CreateEditTestingLabValues
> {
  const { user } = useAuthContext()
  const { testingLabs, refetch } = useTestingLabsContext()
  const all = useCheckPermission(Permission.EditAllTestingLab)
  const some = useCheckPermission(Permission.EditLimitedTestingLab)
  const { toLabeledValues, fromLabeledValues } = useLabTechSelectContext()
  const [edit] = useEditTestingLabMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editTestingLab: {
        testingLab: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: ({ id }) => {
      const userLabIds = (testingLabs ?? []).reduce((ids, { id, labTechs }) => {
        if (labTechs.some((labTech) => labTech.user?.id === user?.id))
          ids.push(id)
        return ids
      }, Array<number>())
      return all || (some && userLabIds.includes(id))
    },
    modal: {
      type: 'simple',
      recordName: 'name',
      initialValues: ({ labTechs, name }) => ({
        name,
        labTechs: toLabeledValues(labTechs),
      }),
      body: <CreateEditBody />,
      onOk: async (lab, { name, labTechs }) => {
        const labTechIds = fromLabeledValues(labTechs)
        if (
          name !== lab.name ||
          notEqual(
            labTechIds,
            lab.labTechs.map(({ id }) => id)
          )
        ) {
          await edit({ variables: { input: { id: lab.id, labTechIds, name } } })
          refetch()
        }
      },
    },
  }
}
